import { useTranslation } from 'react-i18next'
import { useTelegram } from '../hooks/useTelegram'
import { Logo } from './Logo'

export function Header() {
  const { t } = useTranslation()
  const { user } = useTelegram()

  return (
    <header className="px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Logo size={34} />
        <div>
          <h1 className="text-lg font-bold text-gold-500">{t('app.title')}</h1>
          <p className="text-xs text-telegram-hint">{t('app.tagline')}</p>
        </div>
      </div>
      {user && (
        <div className="flex items-center gap-2 bg-telegram-secondary rounded-full px-3 py-1.5">
          <div className="w-6 h-6 rounded-full bg-gold-500 flex items-center justify-center text-xs font-bold text-black">
            {user.firstName.charAt(0).toUpperCase()}
          </div>
          <span className="text-sm text-telegram-text max-w-[80px] truncate">{user.firstName}</span>
          {user.isPremium && <span className="text-sm">⭐</span>}
        </div>
      )}
    </header>
  )
}
